import { OrganizationSortOption } from '@rematter/frontend-lib-api-client';

import { simpleOrganizationFragment } from './fragmentsOrganization';

import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type OrganizationListRecord = QueryAtomResult<
  typeof organizationListQueryAtom
>['organizations'][number];

export const organizationListQueryAtom = createQueryAtomFactory(
  'admin.organizations',
  (params: {
    searchTerm?: string;
    sortBy?: OrganizationSortOption | null;
    pagination?: {
      limit: number;
      offset: number;
    };
  }) => ({
    organizations: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sortBy ? [params.sortBy] : undefined,
        pagination: params.pagination,
      },
      entries: simpleOrganizationFragment,
      page: {
        total: true,
      },
    },
  }),
  {
    select: ({ organizations }) => ({
      total: organizations.page.total ?? 0,
      organizations: organizations.entries.map((org) => ({
        ...org,
        userCount: org.users.length,
      })),
    }),
  },
);
